import React, { useState } from "react";
import { FileText, Files } from "lucide-react";
import TextScrubber from "../components/TextScrubber";
import FileScrubber from "../components/FileScrubber";
import { useI18n } from "../i18n";

const TabBtn = ({ id, active, icon: Icon, label, onClick }) => (
  <button
    data-testid={`tab-${id}`}
    onClick={onClick}
    className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-[13px] font-medium transition-colors active:scale-[0.98] ${
      active ? "bg-white text-black" : "text-slate-400 hover:bg-white/10 hover:text-white"
    }`}
  >
    <Icon className="h-3.5 w-3.5" strokeWidth={1.75} />
    {label}
  </button>
);

export default function Studio() {
  const { t } = useI18n();
  const [tab, setTab] = useState("files");

  return (
    <main className="min-h-[calc(100vh-3.5rem)] bg-[#050505]">
      <div className="border-b border-white/5 bg-[#08080a]">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-4 px-5 py-5">
          <h1 className="font-head text-2xl font-semibold tracking-tight">{t("studio.title")}</h1>
          <div className="ml-auto flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 p-1" data-testid="studio-tabs">
            <TabBtn id="files" active={tab === "files"} icon={Files} label={t("studio.tabFiles")} onClick={() => setTab("files")} />
            <TabBtn id="text" active={tab === "text"} icon={FileText} label={t("studio.tabText")} onClick={() => setTab("text")} />
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 py-8">
        {/* Both tools stay mounted so queues and drafts survive tab switches. */}
        <div className={tab === "files" ? "" : "hidden"}>
          <FileScrubber />
        </div>
        <div className={tab === "text" ? "" : "hidden"}>
          <TextScrubber />
        </div>
      </div>
    </main>
  );
}
